import { __assign, __awaiter, __extends, __generator } from "tslib";
import { namespacedClassnames } from '../../common/namespace-classes';
import { createKeyHandledList } from './key-handled-list/key-handled-list.comp';
import * as React from 'react';
import { Loader } from '../../primitives/loaders/loader/loader';
import { debounce } from '@wix/answers-lib';
import { SearchInput } from '../search-input/search-input';
var searchCount = 10;
var searchOffset = 0;
var FloaterSelect = /** @class */ (function (_super) {
    __extends(FloaterSelect, _super);
    function FloaterSelect() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.doSearchDebounce = debounce(function (term, count, offset, fetchNewItems) {
            if (fetchNewItems === void 0) { fetchNewItems = true; }
            return _this.search(term, count, offset, fetchNewItems);
        }, _this.props.debounceDelay || 200);
        _this.state = {
            items: [],
            loading: true,
            term: ''
        };
        _this.keyHandledList = null;
        _this.recreateList = function (items) {
            var ItemRenderer = _this.props.ItemRenderer;
            var onSelect = function (item, e) {
                if (!item.disabled) {
                    _this.props.onSelect(item, e);
                    _this.search(_this.state.term, searchCount, searchOffset, !_this.props.blockSearchAfterSelect, item);
                }
            };
            var Wrapper = function (props) {
                var handleSelect = function (e) { return onSelect(props.item, e); };
                var className = namespacedClassnames('floater-select-item', { selected: props.selected || props.item.selected, disabled: props.item.disabled });
                return (React.createElement("li", { onMouseDown: handleSelect, onTouchStart: handleSelect, onClick: handleSelect, key: props.index, className: className },
                    React.createElement(ItemRenderer, __assign({}, props))));
            };
            _this.keyHandledList = createKeyHandledList(items, Wrapper, onSelect);
        };
        _this.search = function (term, count, offset, fetchNewItems, selectedItem) {
            if (fetchNewItems === void 0) { fetchNewItems = true; }
            return __awaiter(_this, void 0, void 0, function () {
                var items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            this.setState({ loading: true });
                            return [4 /*yield*/, this.props.search(term, count, offset, fetchNewItems, selectedItem)];
                        case 1:
                            items = _a.sent();
                            this.recreateList(items);
                            this.setState({ loading: false, items: items });
                            return [2 /*return*/];
                    }
                });
            });
        };
        _this.onSearchChange = function (term) {
            _this.setState({ term: term });
            _this.doSearchDebounce(term, searchCount, searchOffset);
        };
        _this.onResetSearch = function () { return _this.onSearchChange(''); };
        _this.handleKeyPress = function (e) {
            if (_this.keyHandledList) {
                _this.keyHandledList.keyHandler(e);
            }
        };
        _this.renderKeyHandledList = function () {
            var RenderedList = _this.keyHandledList.component;
            return React.createElement(RenderedList, null);
        };
        return _this;
    }
    FloaterSelect.prototype.componentWillMount = function () {
        this.search('', searchCount, searchOffset);
    };
    FloaterSelect.prototype.render = function () {
        var _this = this;
        var key = 'floater-select';
        var classNames = namespacedClassnames(key, this.props.className, { 'sticky-search': this.props.stickySearch });
        var isLoading = this.state.loading;
        var hasResults = this.state.items.length !== 0;
        var noResults = React.createElement("div", { className: 'no-results' }, this.props.noResults);
        var emptyState = this.props.emptyState ? React.createElement("div", { className: 'empty-state' }, this.props.emptyState) : noResults;
        var noResultsComp = this.state.term ? noResults : emptyState;
        var listVisible = this.props.listVisible !== false;
        // tslint:disable-next-line:max-line-length
        var renderList = function () { return (React.createElement("div", { className: namespacedClassnames('list-container') }, (isLoading ? React.createElement(Loader, { isCentered: true }) : hasResults ? _this.renderKeyHandledList() : noResultsComp))); };
        var onFocusChange = function (focused) {
            if (focused) {
                if (_this.props.onFocus) {
                    _this.props.onFocus();
                }
            }
            else {
                if (_this.props.onBlur) {
                    _this.props.onBlur();
                }
            }
        };
        var showSearch = this.props.showSearch !== undefined ? this.props.showSearch : true;
        var serachInput = (React.createElement("div", { className: 'search-wrapper' },
            React.createElement(SearchInput, { className: 'floater-select-search-input', onFocusChange: onFocusChange, onSearch: this.onSearchChange, placeholder: this.props.placeholderText, onReset: this.onResetSearch, onKeyDown: this.handleKeyPress, autoFocus: this.props.autoFocus, forceExpanded: true, query: this.state.term })));
        return (React.createElement("div", { className: classNames },
            React.createElement("div", { className: namespacedClassnames('search-field') }, showSearch && serachInput),
            this.props.header,
            listVisible ? renderList() : null,
            this.props.footer));
    };
    return FloaterSelect;
}(React.Component));
export { FloaterSelect };
//# sourceMappingURL=floater-select.comp.js.map